// extracted by mini-css-extract-plugin
export var ad = "layout-module--ad--e3812";
export var btn = "layout-module--btn--8082b";
export var container = "layout-module--container--2dd24";
export var contents = "layout-module--contents--91557";
export var firstview = "layout-module--firstview--29131";
export var main = "layout-module--main--bb351";
export var main_content = "layout-module--main_content--b941a";
export var sidebar = "layout-module--sidebar--a4a72";
export var toph2 = "layout-module--toph2--a2bf7";